export default __webpack_public_path__ + "static/media/moment.d3393e05.png";